import { render, staticRenderFns } from "./NOTFOUND.vue?vue&type=template&id=213e53fc&scoped=true&lang=pug"
import script from "./NOTFOUND.vue?vue&type=script&lang=js"
export * from "./NOTFOUND.vue?vue&type=script&lang=js"
import style0 from "./NOTFOUND.vue?vue&type=style&index=0&id=213e53fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213e53fc",
  null
  
)

export default component.exports